import { useMemo } from "react"
import { observer } from "mobx-react-lite"
import styles from "./styles.module.scss"
import { _t } from "@cruisen/i18n"
import { makeAutoObservable } from "mobx"

class PortListStore {
  areAllPortsVisible: boolean

  constructor() {
    this.areAllPortsVisible = false
    makeAutoObservable(this)
  }

  setAreAllPortsVisible(value: boolean) {
    this.areAllPortsVisible = value
  }
}

export default PortListStore

export const PortList = observer(({ ports }: { ports: string[] }) => {
  const state = useMemo(() => new PortListStore(), [])

  if (!state.areAllPortsVisible && ports.length > 4) {
    const hiddenPortsAmount = ports.length - 3

    return (
      <div className={styles.flex1}>
        <p className={styles.text}>
          {`${ports.slice(0, 3).join(" · ")} · `}
          <span
            className={styles.underline}
            onClick={(e) => {
              e.stopPropagation()
              state.setAreAllPortsVisible(true)
            }}
          >
            {_t("tripOverview.showMorePorts", { amount: hiddenPortsAmount })}
          </span>
        </p>
      </div>
    )
  }

  return (
    <div className={styles.flex1}>
      <p className={styles.text}>{ports.join(" · ")}</p>
    </div>
  )
})
